"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = require("styled-components");
var atoms_utils_theme_1 = require("@lettucegrow/atoms.utils.theme");
var Radio_styled_js_1 = __importStar(require("./Radio.styled.js"));
/**
 * * Radio input
 */
var Radio = function Radio(_ref) {
  var label = _ref.label,
    className = _ref.className,
    isSelected = _ref.isSelected,
    onChange = _ref.onChange,
    dataNw = _ref.dataNw,
    value = _ref.value,
    name = _ref.name;
  return react_1.default.createElement(styled_components_1.ThemeProvider, {
    theme: atoms_utils_theme_1.theme
  }, react_1.default.createElement(Radio_styled_js_1.default, {
    className: className,
    onClick: onChange
  }, react_1.default.createElement(Radio_styled_js_1.InputWrapper, {
    isSelected: isSelected
  }, react_1.default.createElement(Radio_styled_js_1.Input, {
    "data-nw": dataNw,
    type: 'radio',
    value: value,
    name: name
  })), label));
};
Radio.defaultProps = {
  label: ''
};
Radio.propTypes = {
  label: prop_types_1.default.any,
  className: prop_types_1.default.string,
  isSelected: prop_types_1.default.bool,
  onChange: prop_types_1.default.func,
  value: prop_types_1.default.string,
  name: prop_types_1.default.string,
  dataNw: prop_types_1.default.string
};
exports.default = Radio;